import { Component, OnInit } from '@angular/core';
import { Services1Service } from '../services/services1.service';

const GRAPH_ENDPOINT = 'https://graph.microsoft.com/v1.0/me';

type ProfileType = {
  givenName?: string,
  surname?: string,
  userPrincipalName?: string,
  id?: string,
  photoURL?: string
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  loginDisplay = false;

  profile!: ProfileType;

  constructor(
    private service1:Services1Service
    ) { }

  ngOnInit(): void {}

  setLoginDisplay(){
    return this.service1.loginDisplay;
  }

  openBuild(){
    this.service1.openBuild();
   }

   openBuild_libre(){
    this.service1.openBuild_libre();
   } 
}
